import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db, auth } from "@/lib/firebase";

// Fire-and-forget analytics event logger. Never throws.
export async function logEvent(type, data = {}) {
  try {
    await addDoc(collection(db, "events"), {
      type,
      userId: auth.currentUser?.uid || "guest",
      email: auth.currentUser?.email || null,
      path: typeof window !== "undefined" ? window.location.pathname : "",
      referrer: typeof document !== "undefined" ? document.referrer || null : null,
      userAgent: typeof navigator !== "undefined" ? navigator.userAgent.slice(0, 140) : "",
      timestamp: serverTimestamp(),
      ...data,
    });
  } catch (e) {
    // silent — analytics should never break UX
  }
}
